import { create } from "zustand";
import { ProductsAPI } from "../Helpers/ConfigProvider";


const useOccasionStore = create((set, get) => ({
  occasions: [],
  errors: [],
  loading: false,
  selectedOccasion: null,
  getOccasions: async () => {
    set({ loading: true, errors: [] });
    const response = await fetch(`${ProductsAPI}/Occasions/Overview`);

    if (!response.ok) {
      const error = await response.text();
      set({ errors: [...get().errors, error], loading: false });
      return;
    }
    try {
      const data = await response.json();
      set({ occasions: data, errors: [], loading: false });
    } catch (error) {
      set({
        errors: [...get().errors, "Failed to parse occasions"],
        loading: false,
      });
    }
  },
  setSelectedOccasion: (occasion) => {
    set({ selectedOccasion: occasion });
  },
  getOccasionByFriendlyName:  async (friendlyName) => {
    const occasion = get().occasions.find(
      (occ) => occ.FriendlyName === friendlyName
    );
    if (occasion) {
      set({ selectedOccasion: occasion });
      return occasion;
    } else {
      set({ errors: [], selectedOccasion: null, loading: true });

      const response = await fetch(`${ProductsAPI}/Occasions/${friendlyName}`);
        
          if (!response.ok) {
            const error = await response.json();
            set({ errors: [...get().errors, error], loading: false });
            return;
          }
          try {
            const data = await response.json();
            set({ selectedOccasion: data, errors: [], loading: false });
            return data;
          } catch (error) {
            set({
              errors: [...get().errors, "Failed to get occasion"],
              loading: false,
            });
            return null;
          }
        
      
    }
  },
}));

export default useOccasionStore;
